import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import Loading from '../components/Loading.jsx';
import requireAuth from '../lib/requireAuth.jsx';
import { selectUser } from '../modules/auth.js';
import NotFoundPage from './_not-found';

const mapStateToProps = (state) => ({
  hasAccess: Boolean(selectUser(state).aiAssistantAccess),
});

// Entry point for the external AI Assistant: users without access to it
// in the current organization get the 404 page instead of the redirect.
const AIAssistant = ({ hasAccess }) => {
  const { slug } = useParams();

  useEffect(() => {
    if (hasAccess) {
      const chatUrl = process.env.AI_CHAT_URL.replace(/\/+$/, '');
      window.location.replace(`${chatUrl}/${encodeURIComponent(slug)}`);
    }
  }, [hasAccess, slug]);

  if (!hasAccess) {
    return <NotFoundPage />;
  }

  return (
    <div className="component-centered">
      <Loading />
    </div>
  );
};

export default requireAuth(connect(mapStateToProps)(AIAssistant));
